import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@capitalise/ui-design-system';

const SearchClientHeaderAlpha = ({ title, maxClientsCount }) => (
  <Box gridArea="header">
    <Box typography="heading-32" color="grey-900">
      {title}
    </Box>
    {maxClientsCount ? (
      <Box typography="body-16" color="grey-900" mt="3xsmall">
        {`On your current plan you can add up to ${maxClientsCount} clients.`}
      </Box>
    ) : null}
  </Box>
);

SearchClientHeaderAlpha.propTypes = {
  maxClientsCount: PropTypes.number,
  title: PropTypes.string,
};

SearchClientHeaderAlpha.defaultProps = {
  maxClientsCount: null,
  title: 'Select clients that you’d like to Monitor.',
};

export default SearchClientHeaderAlpha;
